// App.vue

<template>
  <div class="global-app" data-app>
    <UserMessage v-if="umContext.isActive" />
    <router-view style="overflow: scroll" class="active-route-view" />
  </div>
</template>

<script>
import UserMessage from './components/globalUiComponents/userMessage/UserMessage.vue'
export default {
  // Because App.vue is always live and not re-mount, we have to watch on geters change to re assign value to make it "Reactive"
  watch: {
    getUserMessage (newUM, prevUM) {
      this.umContext = newUM
    }
  },
  beforeMount () {
    this.appendHj()
    this.appendConvert()
    this.umContext = this.getUserMessage
    this.initGlobalListeners()
    this.checkDeviceSize()
  },
  data () {
    return {
      umContext: {},
      mobileMinSize: 480
    }
  },
  components: {
    UserMessage
  },
  computed: {
    getUserMessage () {
      return this.$store.getters['errors/getUserMessage']
    }
  },
  methods: {
    appendHj () {
      let script = document.createElement('script')
      const isDevMode = process.env.NODE_ENV !== 'production'
      const hjId = isDevMode ? 2761751 : 1365936
      script.innerHTML = `;(function(h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function() {
            ;(h.hj.q = h.hj.q || []).push(arguments)
          }
        h._hjSettings = { hjid: ${hjId}, hjsv: 6 }
        a = o.getElementsByTagName('head')[0]
        r = o.createElement('script')
        r.async = 1
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
        a.appendChild(r)
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')`
      document.head.appendChild(script)
    },
    appendConvert () {
      let script = document.createElement('script')
      const isDevMode = process.env.NODE_ENV !== 'production'
      const envKey = isDevMode ? 10042534 : 10043273
      script.type = 'text/javascript'
      script.src = `//cdn-4.convertexperiments.com/js/10042080-${envKey}.js`
      document.head.appendChild(script)
    },
    checkDeviceSize () {
      let isMobile = false
      let innerWidth = window.innerWidth
      if (innerWidth <= this.mobileMinSize) {
        isMobile = true
      }
      this.setIsMobile(isMobile)
    },
    initGlobalListeners () {
      window.addEventListener('resize', this.handleResize)
    },
    handleResize (e) {
      let isMobile = false
      let { innerWidth } = e.target
      if (innerWidth <= this.mobileMinSize) {
        isMobile = true
      }
      this.setIsMobile(isMobile)
    },
    setIsMobile (mode) {
      this.$store.commit('onboarding/setKeyValue', {
        prop: 'isMobile',
        value: mode
      })
    }
  }
}
</script>


<style lang="scss">
@import '@/styles/global.scss';
</style>
<style src="./css/fonts.css" async defer></style>
<style src="./css/desktop-style.scss" lang="scss" async defer></style>
<style src="./css/mobile-style.scss" lang="scss" async defer></style>



// WEBPACK FOOTER //
// src/App.vue